import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { General } from "../../../siteManagement/general";
import { Helper } from "../../core/util/helper";
import EditDokumentCategory, { DocumentCategory, EditDokumentCategoryProps } from "./editDocumentCategory";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { SheetEventType } from "../../../siteManagement/sheet";
import { ContextGeneralSettingsApp } from "../generalSettings";
import { Metadata } from "../../core/components/commonApp";
import React from "react"
export default class EditDocumentCategoriesGrid extends React.Component<EditDocumentCategoriesProps, EditDocumentCategoriesState> {
    private _translations: string[] = null;
    private _options: any = null;
    constructor(props) {
        super(props);
        this.state = { gridData: [], deleteButtonEnabled: false };
    }
    private _getGridData = () => {
        let url = "DocumentsSettings/GetAllCategories";
        HTTPService.get<JsonResultClass>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _openEditCategory = (dataItem: KeyValue = null) => {
        let entityURL = "DocumentsSettings/GetCategory";
        if (dataItem != null) {
            entityURL += "/?Id=" + dataItem.Key;
        }

        HTTPService.chainBatch
            .add<JsonResultClass>(entityURL)
            .add<Metadata>(Helper.getMetaData("documentCategory"))
            .promise()
            .then(result => {                
                const entity = result[0];
                if (entity.Code != 0) {
                    NotificationHelper.showErrorMessage(entity.Message);
                }
                const metadata = result[1];
                this._initWindow(entity.Data, metadata);

            });
    }

    private _initWindow = (entity: DocumentCategory, metaData: any) => {

        const props: EditDokumentCategoryProps = {
            dataSources: {},
            metadata: metaData as Metadata,
            entity: entity,
            isWindow: true,
            context: {},
            title: ""
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, () => {
            this._getGridData();
        });
        sheet.show(() => {
            sheet.mountContent(EditDokumentCategory, props);
        });
    }

    private _deleteCategory = (dataItem: KeyValue) => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                const url = "DocumentsSettings/DeleteCategory?Id=" + dataItem.Key;
                HTTPService.get<JsonResultClass>(url).then(result => {
                    if (result.Code == 0) {
                        if (result.Code === 0) {
                            this._getGridData()
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    }
                });
            }
        });
    }

    private _createGrid = () => {

        const fullLoaded: boolean = Helper.hasValue(this._translations) && Helper.hasValue(this._options);
        if (fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.deleteButtonEnabled });
            let grid = (
                <Grid data={this.state.gridData} options={this._options} id="documentCategoriesGrid" onSelectionChanged={this._handleSelectedChange}
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleSelectedChange = (dataItem: KeyValue) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ deleteButtonEnabled: Helper.getValueOrDefault(dataItem.IsDeleteable, false) });
        } else {
            this.setState({ deleteButtonEnabled: false });
        }
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: KeyValue) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this._openEditCategory(dataItem)
                break;
            case (ToolBarStandardButtonType.NEW):
                this._openEditCategory();
                break;
            case (ToolBarStandardButtonType.DELETE):
                this._deleteCategory(dataItem);
                break;
        }
    }

    componentDidMount() {
        this._translations = this.props.context.translations;
        this._options = this.props.context.documentCategoriesGridOptions;
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        return (
            <>
                {grid}
            </>);
    }
};

export interface EditDocumentCategoriesProps {
    context: ContextGeneralSettingsApp;
}

interface EditDocumentCategoriesState {
    gridData: KeyValue[];
    deleteButtonEnabled: boolean;
}

interface KeyValue {
    Key: number;
    Value: string;
    IsDeleteable: boolean;
}